import React from 'react';
import NavigationBar from '../../components/NavigationBar/NavigationBar';

function Pricing() {

  return (
    <div>
      <NavigationBar />

      <main>
        <h1>Pricing</h1>
        <p>Text content goes here...</p>
      </main>
    </div>
  );
}

export default Pricing;
